const constants = {
  zoomMeetingURL: "https://us04web.zoom.us/j/6863023729?pwd=MTg2T3p4UHdPV09zNGhmSDFnU1ZWdz09",
  emailServiceId: 'service_z1f4as4',
  emailTemplateId: 'template_58n3184',
  emailUserId: 'user_otuDSTayexQfMwTkhq19G',
  myEmail: 'stanley.chan.social@gmail.com'
};

export default Object.freeze(constants);
